export const toUTCLocaleDateString = (date) => {
	if(!(date instanceof Date))
		throw new TypeError('date must be a Date.');
	return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000).toLocaleDateString();
};

export const toUTCLocaleTimeString = (date) => {
	if(!(date instanceof Date))
		throw new TypeError('date must be a Date.');
	return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000).toLocaleTimeString();
};

export const toUTCLocaleDateTimeString = (date) => {
	return `${toUTCLocaleDateString(date)} ${toUTCLocaleTimeString(date)}`;
};

export default toUTCLocaleDateString;